export default __webpack_public_path__ + "static/media/LINEO-LOGO.0471dc74.png";